module.exports = __webpack_public_path__ + "img/gaowei.eb0b2f8a.png";